import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import { getChannelVariantLinkAttachment } from '../../channelVariantToCreatePostInput'
import {
  ensureLinkAttachmentProtocol,
  mapLinkAttachment,
} from '../../mapAssets'
import type { MapperContext } from '../../types'
import { clearable } from '../shared/clearable'
import type { ServiceMapperEntry } from '../types'

// A Note has no thread and no other per-network field. The link attachment is
// tri-stated through `clearable`: omitted on create, `null` on edit to clear it.
//
// `ctx.channelVariant` (when present) supplies the same link attachment.
export function mapSubstack(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const linkAttachment = variant
    ? getChannelVariantLinkAttachment(variant)
    : mapLinkAttachment(draft)

  return {
    substack: {
      linkAttachment: clearable(
        linkAttachment && ensureLinkAttachmentProtocol(linkAttachment),
        ctx,
      ),
    },
  }
}

export const substack: ServiceMapperEntry = {
  mapper: mapSubstack,
}
